"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateHealing = exports.calculateAttackHit = exports.testCrit = exports.mkAttackTypeTick = void 0;
const Random_1 = require("../../utils/Random");
const Round_1 = require("../utils/Round");
function mkAttackTypeTick(key) {
    return `${key}_tick`;
}
exports.mkAttackTypeTick = mkAttackTypeTick;
function testCrit(critChance) {
    critChance = (0, Round_1.roundTo)(critChance / 100, 3);
    const roll = (0, Random_1.random)(1, 1000);
    return {
        roll: (0, Round_1.roundTo)(roll * .1, .1),
        didCrit: (roll / 1000 + critChance) >= 1
    };
}
exports.testCrit = testCrit;
function calculateAttackHit(critChance) {
    critChance = (0, Round_1.roundTo)(critChance / 100, 3);
    const result = {
        hit: false,
        crit: false,
        roll: 0,
        total: 0,
    };
    const rawRoll = (0, Random_1.random)(1, 1000);
    result.roll = (0, Round_1.roundTo)(rawRoll * .1, 1);
    result.total = result.roll;
    if (result.roll < 3) {
        result.hit = false;
        // always 2% chance to miss!
        return result;
    }
    result.hit = true;
    result.crit = (rawRoll / 1000 + critChance) >= 1;
    return result;
}
exports.calculateAttackHit = calculateAttackHit;
function calculateHealing(baseAmount, attributeModifier, critChance, critMultiplier) {
    const result = {
        amountRoll: (0, Round_1.roundTo)((0, Random_1.random)(800, 1200) / 1000, 3),
        critRoll: (0, Round_1.roundTo)((0, Random_1.random)(0, 1000) / 1000, 3),
        crit: false,
        amount: 0
    };
    critChance = (0, Round_1.roundTo)(critChance / 100, 3);
    critMultiplier = (0, Round_1.roundTo)(critMultiplier / 100, 3);
    result.crit = (result.critRoll + critChance) >= 1;
    const critDamageMultiplier = result.crit ? 1 + critMultiplier : 1;
    result.amount = Math.ceil(result.amountRoll * (baseAmount + attributeModifier) * critDamageMultiplier);
    return result;
}
exports.calculateHealing = calculateHealing;
